module.exports = __webpack_public_path__ + "static/media/login_version.c27afd5e.svg";